module.exports = __webpack_public_path__ + "img/javascript.60e9f82a.jpg";